<div class="widget-container" #ScatterPlotChartDiv>
    <scatter-plot-chart
    [headerConfig]="item.config?.widget_header_config"
    [config]="config"
    [data]="data"
    [item]="item"
    [pageKey]="pageKey"
    [error_name]="error_name"
    [prefrenceConfig]="prefrenceConfig"
    >
    </scatter-plot-chart>
</div>